import { LucideIcon } from "lucide-react"
import * as React from "react"
import { cn } from "../utils"

export interface InputProps extends React.ComponentProps<"input"> {
  icon?: LucideIcon
  leftText?: string
  rightText?: string
  wrapperClassName?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, icon: Icon, leftText, rightText, wrapperClassName, ...props }, ref) => {
    return (
      <div className={cn("relative flex w-full items-center", wrapperClassName)}>
        {Icon && <Icon className="absolute left-3 h-4 w-4 text-muted-foreground" />}
        {leftText && (
          <span className="text-muted-foreground text-sm border border-r-0 border-input rounded-l-md bg-muted self-stretch flex items-center px-3 -z-10">
            {leftText}
          </span>
        )}
        <input
          type={type}
          className={cn(
            "flex w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
            Icon && "pl-9",
            leftText && "rounded-l-none",
            rightText && "rounded-r-none",
            className,
          )}
          ref={ref}
          {...props}
        />
        {rightText && (
          <span className="text-muted-foreground text-sm border border-l-0 border-input rounded-r-md bg-muted self-stretch flex items-center px-3 -z-10">
            {rightText}
          </span>
        )}
      </div>
    )
  },
)
Input.displayName = "Input"

export { Input }
